import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import moment from 'moment'
const { WizSpin, WizCard, WizForm, WizGallery } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/callCar/look') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('callCarLook', record)
        } else {
            record = Session.get('callCarLook') || {}
        }
    }
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/callAccessories/look') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('callAccessoriesLook', record)
        } else {
            record = Session.get('callAccessoriesLook') || {}
        }
    }
    return record
}

class SalesOpeningLook extends WizContainer {

    componentName = 'SalesOpeningLook'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record,
            visible: false,
            index: 0
        }
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { recordId } = this.state.record
        this.doAction({
            path: 'counselingProcess/callCarDetail',
            payload: {
                key: 'callCarDetail@' + recordId,
                apiParams: {
                    id: recordId
                }
            }
        })
    }

    render() {
        let { detail, counselingProcessLoading } = this.props
        let { visible, index, record } = this.state
        const { moduleType } = record
        let infoProps = {
            ref: 'info',
            columns: [{
                title: `首次${moduleType === 0 ? '拷车' : '拷配件'}日期`,
                name: 'submitTime',
                dataIndex: 'submitTime',
                formItem: {
                    type: 'custom',
                    render: (r, f) => r && r.submitTime ? moment(r.submitTime).format('YYYY-MM-DD') : ''
                }
            }, {
                title: `首次${moduleType === 0 ? '拷车' : '拷配件'}截图`,
                name: 'imgs',
                name: 'fileIds',
                dataIndex: 'fileIds',
                formItem: {
                    type: 'custom',
                    render: (r, f) => {
                        let fileIds = r && r.fileIds ? r.fileIds : []
                        let imgs = fileIds.map((fileId, index) => getOssFilePath(fileId))
                        return (
                            <div style={{ display: 'flex', 'flex-wrap': 'wrap' }}>
                                {imgs.map((img, index) => {
                                    return (
                                        <div key={'callCarImg_', index} style={{ padding: 8 }}>
                                            <img height={80} width={80} src={img} onClick={() => this.setState({ visible: true, index })} />
                                        </div>
                                    )
                                })}
                                <WizGallery
                                    visible={visible}
                                    sources={imgs}
                                    index={index}
                                    onCancel={() => this.setState({ visible: false })}
                                />
                            </div>
                        )
                    }
                }
            }],
            record: detail.data,
            preview: null,
            footer: null,
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            },
            style: { maxWidth: '100%', width: '100%' }
        }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <WizCard title={`查看首次${moduleType === 0 ? '拷车' : '拷配件'}`}>
                    <WizForm {...infoProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { recordId } = findParamRecord(ownProps.history)
    const detail = modelUtils.getModelEntity(counselingProcess, 'callCarDetail@' + recordId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        detail,
        ...loading
    }
}

export default connect(mapStateToProps)(SalesOpeningLook)


